import { render, staticRenderFns } from "./AddStore.vue?vue&type=template&id=22c5b797&scoped=true&"
import script from "./AddStore.vue?vue&type=script&lang=js&"
export * from "./AddStore.vue?vue&type=script&lang=js&"
import style0 from "./AddStore.vue?vue&type=style&index=0&id=22c5b797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c5b797",
  null
  
)

export default component.exports